<template>
  <!-- filter-common  .fc -->
  <div class="fc">
    <div class="fc-item">
      <div class="fc-item-title">类别：</div>
      <div class="fc-item-content" :class="{open: show}">
        <!-- <div class="fcc-brand s-red" @click="select('全部')">全部</div> -->
        <div
          class="fcc-brand"
          v-for="(item, index) in actList"
          :key="'categoryList-' + index"
          @click="select(item,index)"
          :class="index == selectIndex ? 's-red' :''"
        >{{item}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // 类别筛选
  name: "filter-common3",
  data() {
    return {
      show: false,
      actList: ["全部","热门", "最新发布"],
      selectIndex : 0,
    };
  },
  components: {},
  computed: {},
  methods: {
    select(type,index){
      this.selectIndex = index;
      this.$emit('select',type);
    }
  }
};
</script>

<style scoped lang="scss">
.fc {
  background-color: #fff;
  padding: 20px 20px 0;
  &-item {
    &.s-1 {
      margin-top: 19px;
    }
    border-bottom: 1px dotted #bfbfbf;
    display: flex;
    &-title {
      width: 55px;
      color: #808080;
    }
    &-content {
      &.open {
        max-height: initial !important;
        overflow: initial;
      }
      flex: 1;
      overflow: hidden;
      .fcc-brand {
        display: inline-block;
        margin-right: 38px;
        margin-bottom: 17px;
        font-size: 14px;
        color: #333;
        cursor: pointer;
      }
    }
    &-tool {
      font-size: 14px;
      color: #666;
      width: 80px;
      text-align: right;
      display: flex;
      span {
        align-self: flex-end;
        margin-bottom: 17px;
        cursor: pointer;
      }
    }
    &:last-child {
      border-bottom: none;
    }
  }
}
.s-red {
  color: #d13119 !important;
}
</style>
